import { ElasticsearchFieldModel } from '../../../elasticsearch/elasticsearch-field';
import { ElasticsearchEnhancedFilterModel, } from '../../../elasticsearch/elasticsearch-filter';
import LuceneFilterParser from '../../../osd/filters/parsers/lucene-filter-parser';
import { BaseExploreFilterParser } from './base';
/**
 * Elastic to ElasticsearchFilterModel 'LUCENE' filter parser
 */
export class ExploreFilterLuceneFilterParser extends BaseExploreFilterParser {
    constructor() {
        super(new LuceneFilterParser());
    }
    getFilter(elasticFilter, negate) {
        const metadata = this.getMetadata(elasticFilter, negate);
        if (!metadata)
            return null;
        const filter = new ElasticsearchEnhancedFilterModel();
        filter.type = 'LUCENE';
        filter.negate = metadata.negate;
        filter.field = new ElasticsearchFieldModel();
        filter.value = metadata.key ?? null;
        return filter;
    }
    getElasticFilter(filter) {
        if (filter.type !== 'LUCENE')
            return null;
        const parsedValue = filter.value?.replaceAll('\n', ' ');
        return {
            [this.baseFilterParser.elasticKey]: {
                query: parsedValue,
            },
        };
    }
}
//# sourceMappingURL=lucene.js.map